module.exports = __webpack_public_path__ + "img/iconsubject.38a8843e.png";